import { IRootState } from '../../../store'
import { IPatientMedicationsOptionsState } from '../store/options.types'

export const getPatientMedicationsOptionsSelector = (state: IRootState): IPatientMedicationsOptionsState =>
  state.options.patientMedicationsOptions
